/* eslint no-console: off */
import { RedirectError } from '@/core/http/redirect.interceptor';
import { JL } from 'jsnlog';

class LoggingService {
    public debug(logObject: any): void {
        if (this.isDebugMode) {
            // eslint-ignore-next-line
            console.log(logObject);
        } else {
            JL().debug(logObject);
        }
    }

    public info(logObject: any) {
        if (this.isDebugMode) {
            // eslint-ignore-next-line
            console.info(logObject);
        } else {
            JL().info(logObject);
        }
    }

    public warn(logObject: any) {
        if (this.isDebugMode) {
            // eslint-ignore-next-line
            console.warn(logObject);
        } else {
            JL().warn(logObject);
        }
    }

    public error(logObject: any) {
        if (isWhitelisted(logObject)) return;

        if (this.isDebugMode) {
            // eslint-ignore-next-line
            console.error(logObject);
        } else {
            JL().error(logObject);
        }

        function isWhitelisted(logObject: any) {
            if (logObject && logObject instanceof RedirectError) return true;
            return false;
        }
    }

    public exception(logObject: any, e: any) {
        if (this.isDebugMode) {
            // eslint-ignore-next-line
            console.error(logObject, e);
        } else {
            JL().fatalException(logObject, e);
        }
    }

    get isDebugMode() {
        return process.env.NODE_ENV !== 'production';
    }
}

export default new LoggingService();
